import { createCookieConsentSubmission } from '../utils/cookieConsentSubmission.mjs';

// The paths of the cookie-consent.store and sanctum.csrf-cookie routes; a
// feature test keeps them in sync with the routes.
export const COOKIE_CONSENT_URL = '/cookie-consent';
export const CSRF_REFRESH_URL = '/sanctum/csrf-cookie';

const localStorageOrNull = () => {
    try {
        return window.localStorage;
    } catch {
        return null;
    }
};

let submission = null;

// One recorder for the whole page, shared by the cookie banner and the embeds
// that ask for their own consent, so their records keep the order they were given in.
export function cookieConsentSubmission() {
    submission ??= createCookieConsentSubmission({
        storage: localStorageOrNull(),
        submit: (choice) => axios.post(COOKIE_CONSENT_URL, choice, { timeout: 10000 }),
        refreshCsrf: () => axios.get(CSRF_REFRESH_URL, { timeout: 10000 }),
    });

    return submission;
}
